import apiDashboard from '@/api/vo/dashboard';

const defaultState = () => ({
	listDashboardInfo: {},
	leftOver: {},
	growthSummary: [],
	networkSummary: [],
	transactionSummary: [],
	serialCount: [],
	responSukses: {},
	responseError: {},
	konfirmResponse: {},
	bonusPotency: {},

	referral: '',
});

const state = defaultState();

const getters = {

};

const mutations = {

	setDashboardInfo(state, data) {
		state.listDashboardInfo = data.data;
	},
	setLeftOver(state, data) {
		state.leftOver = data.data;
	},
	setGrowthSummary(state, data) {
		state.growthSummary = data.data;
	},
	setNetworkSummary(state, data) {
		state.networkSummary = data;
	},
	setTransactionSummary(state, data) {
		state.transactionSummary = data;
	},
	setSerialCount(state, data) {
		state.serialCount = data.data;
	},
	setBonusPotency(state, data) {
		state.bonusPotency = data.data;
	},

	setReferral(state, data) {
		state.referral = data;
	},

	saveResponseError(state, data) {
		state.responseError = data;
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
	},
};

const actions = {
	getDashboardInfo({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getDashboardInfo(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDashboardInfo', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {			
				commit('setDashboardInfo', {});
				reject()
			});
		});
	},
	getLeftover({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getLeftover(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setLeftOver', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Sisa belanja tidak dapat ditampilkan, silakan muat ulang halaman'
				}, { root: true });
				reject()
			});
		});
	},
	getGrowthSummary({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getGrowthSummary(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setGrowthSummary', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setGrowthSummary', []);
				reject()
			});
		});
	},
	getTotalMember({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getTotalMember(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setNetworkSummary', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setNetworkSummary', []);
				reject()
			});
		});
	},
	getTransactionSummary({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getTransactionSummary(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionSummary', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionSummary', []);
				reject()
			});
		});
	},
	getSerialCount({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getSerialCount(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSerialCount', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDashboardInfo', {});
				reject()
			});
		});
	},
	getBonusPotency({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getBonusPotency(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setBonusPotency', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setBonusPotency', {});
				reject()
			});
		});
	},
	getReferral({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getReferral(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setReferral', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Link referral tidak dapat ditampilkan, silakan muat ulang halaman'
				}, { root: true });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;

			}
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};